import { cva } from 'class-variance-authority'

export const spinnerVariants = cva(
  'animate-spin shrink-0 rounded-full border-solid border-current border-t-transparent',
  {
    variants: {
      size: {
        sm: 'h-2.5 w-2.5 border-[1.5px]',
        md: 'h-3 w-3 border-[1.5px]',
        lg: 'h-3.5 w-3.5 border-[1.5px]',
        xl: 'h-4 w-4 border-2',
        '2xl': 'h-8 w-8 border-[3px]',
        '3xl': 'h-12 w-12 border-4',
      },
    },
  },
)
